import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { Label } from 'core/components/label';
import { brandConstants } from 'brand-config';

// Small note under "Billing Details" in the offer settings. The text is brand-configurable
// via the SMALL_BILLING_NOTE brand constant (#33401): Branch shows the credit-card fee note,
// while the mutual carriers set it blank because the statement is inaccurate for them. A blank
// (or missing) constant renders nothing, even when `show` is true.
const SmallBillingNote = ({ show }) => {
  const note = brandConstants?.SMALL_BILLING_NOTE;
  if (!show || !note) {
    return null;
  }
  return (
    <Grid item xs={6}>
      <Label type="noteSmall">{note}</Label>
    </Grid>
  );
};

SmallBillingNote.propTypes = {
  show: PropTypes.bool
};

SmallBillingNote.defaultProps = {
  show: false
};

export default SmallBillingNote;
